import { IExtendedTab } from "components/ExtendedTabs/ExtendedTabs.types";
import { ModelCompareTab } from "../GettingStartedWithUniFi.types";
import { IHeroSection } from "../_components/DesktopHeroSimple/DesktopHeroSimple.types";

import SwitchingImage from "../assets/tabs/compare/enterprise.png";

import MultiSiteHeroVideo from "../assets/tour/multi-site/multi-site.mp4";
import MultiSiteHeroLoopVideo from "../assets/tour/multi-site/multi-site-loop.mp4";
import MultiSiteHeroPoster from "../assets/tour/multi-site/multi-site.jpg";

import MultiSiteMobileHeroVideo from "../assets/tour/mobile/multi-site/intro.mp4";
import MultiSiteMobileHeroLoopVideo from "../assets/tour/mobile/multi-site/intro-loop.mp4";
import MultiSiteMobileHeroPoster from "../assets/tour/mobile/multi-site/intro.jpg";

export const MULTI_SITE_DEPLOYMENT_SWITCHING_TAB = {
  id: ModelCompareTab.Switching,
  label: "gettingStartedWithUniFi.compareTabs.switching",
  image: SwitchingImage,
} satisfies IExtendedTab;

export const DEPLOYMENT_HERO_CONFIG = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.multiSiteDeployment",
  poster: MultiSiteHeroPoster,
  src: MultiSiteHeroVideo,
  loopSrc: MultiSiteHeroLoopVideo,
} satisfies IHeroSection;

export const MULTI_SITE_DEPLOYMENT_MOBILE_CONFIG = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.multiSiteDeployment",
  poster: MultiSiteMobileHeroPoster,
  src: MultiSiteMobileHeroVideo,
  loopSrc: MultiSiteMobileHeroLoopVideo,
} satisfies IHeroSection;
